import React from 'react';
import { styled } from '@volkswagen-onehub/components-core';
import {FavouritePage} from '../Filters/FavouritePage';
import { Route } from '../../../utils/use-route';
import { VolksKlickPageHeader } from '../../VolksKlickPageHeader';
import { useLocation } from 'react-router-dom';

const FavFaqContainer = styled.div`
  flex: 0 0 auto;
  margin: 0;
  max-width: 1750px;
  display: flex;
  align-items: baseline;
  column-gap: ${props => props.theme.size.dynamic0100};
  justify-content: flex-end;
  align-items: center;
`;

export default () => {

  const location = useLocation();

  return (
    location.pathname == '/' + Route.RESULTS
    ? <FavFaqContainer>
        <VolksKlickPageHeader />
        <FavouritePage />
    </FavFaqContainer>
    : null
  );
};
